
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import conf from "./../../config/base.js";
import { routerNames, invoiceTitleType } from "@/common/js/const.js";
import { setToken, getToken } from "@/common/js/common.js";
import regexpValid from "@/common/js/regexp.js";
import { getWxizedUrl } from "@/common/js/common";
import Box from 'vux/src/components/box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {
name: routerNames.LoginScan,
components: {
Box,
Alert,
Group,

Cell,




XHeader,
XButton,
XInput,
XTextarea,
Search
},
data() {
return {
isWechat: ____isWechatBrowser(),
topHeight: ____hasHeader ? "46px" : "0px",
message: ""
};
},
created() {},
activated() {
var $self = this;

if (!$self.isWechat) {
$self.message = "请使用微信扫描二维码";
return;
}
const rid = $self.$route.query.rid;
window.location.href = getWxizedUrl(
"STATE",
"/xforce/#/login/scan?",
"_" + rid
);
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {}
};
